
import React, { useState, useEffect, useLayoutEffect } from 'react';
import PropTypes from "prop-types";

import { apiConfig } from 'config/apiConfig'

import useFetchWithMsal from 'hooks/useFetchWithMsal';
import { ProgressIndicator, useProgressIndicator } from 'components/Elements/ProgressIndicator';
import DataBoundSelect from 'components/Elements/DataBound/Dropdown';
import SoftTypography from 'components/SoftTypography';
import { propTypes } from 'react-bootstrap/esm/Image';
import DataBoundList from 'components/Elements/DataBound/List';


const InvitationSelector = ({ cardroom, union, club, value, readonly, placeholder, emptyValue, onSelectionChanged, type, onBuildListItem, reload, maxHeight }) => {

    // alert(value);
    const [invitations, setInvitations] = useState(null);
    const [retryCounter, setRetryCounter] = useState(0);

    function handleRetry() {
        setRetryCounter(retryCounter + 1);
    }
    const [showProgress, progressIndicatorProps] = useProgressIndicator("wait", "retrieving invitations...", handleRetry)

    const [availableOptions, setAvailableOptions] = useState(null);

    const [selectedValue, setSelectedValue] = useState(value ? value : emptyValue);
    const [selectedIndex, setSelectedIndex] = useState(null);

    function getSelectedIndex() {
        let dataSource = availableOptions; // getDataSource();

        if (!dataSource) return -1;
        if (!selectedValue) return -1;

        for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id == selectedValue.id || dataSource[i].id == selectedValue) {
                return i;
            }
        }

        return -1;
    }

    function findValueInDataSource(v) {
        let dataSource = getDataSource();

        if (!dataSource) return null;
        if (!v) return null;

        for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id == v.id || dataSource[i].id == v) {
                return dataSource[i];
            }
        }

        return -1;
    }

    function getDataSource() {

        if (!invitations) return null;

        let rows = [...invitations];

        if (rows.length > 0) {
            rows.sort(function (a, b) {
                if (a.sendToAddress < b.sendToAddress) { return -1; }
                if (a.sendToAddress > b.sendToAddress) { return 1; }
                return 0;
            });
        }

        if (emptyValue) {
            rows.unshift(emptyValue);
        }

        return rows;
    }

    function handleInvitationChange({ item, index }) {
        setSelectedIndex(null);
        setSelectedValue(item);

        if (onSelectionChanged) {
            onSelectionChanged(item);
        }
    }

    const { error, execute } = useFetchWithMsal({
        scopes: apiConfig.club.scopes.read,
    });

    useEffect(() => {
        if (reload === true) {
            setInvitations(null);
            setSelectedIndex(-1);
        }
    }, [reload]);

    useEffect(() => {
        if (!invitations) {

            progressIndicatorProps.setMode("wait");
            progressIndicatorProps.setMessage("retrieving referral schedules...")
            showProgress();

            //[HttpGet("{unionId:Guid}/casino/{casinoId:Guid}/invitation", Name = "GetUnionInvitations")]
            // [HttpGet("{unionId:Guid}/casino/{casinoId:Guid}/clubs/{clubId:Guid}/invitation", Name = "GetClubInvitations")]
            let url = "/union/" + union.id + "/casino/" + cardroom.id;
            if (club) url += "/clubs/" + club.id;
            url += "/invitation";

            execute("GET", apiConfig.club.endpoint + url).then((response) => {
                if (response) {
                    setInvitations(response);
                }
                progressIndicatorProps.close();

            }).catch((e) => {
                progressIndicatorProps.setMode("errorWithRetry");
                progressIndicatorProps.setMessage("Unable to retrieving invitations, please try again...")
            });
        }

    }, [invitations, execute, retryCounter]);

    useEffect(() => {
        if (availableOptions) {
            setSelectedIndex(getSelectedIndex());
        }

    }, [availableOptions, selectedIndex, selectedValue]);

    useEffect(() => {

        if (invitations) {
            setAvailableOptions(getDataSource());
        }

        setSelectedValue(findValueInDataSource(value));

    }, [invitations, value]);

    return <>
        <ProgressIndicator  {...progressIndicatorProps} />
        {!progressIndicatorProps.visible ? <>
            {readonly ?
                <SoftTypography
                    variant="caption"
                    fontWeight="regular"
                    color="dark"
                > {selectedValue ? selectedValue.name : "[None]"}
                </SoftTypography> : <>{availableOptions ?
                    <>
                        {type === "dropdown" ?
                            <DataBoundSelect placeholder={placeholder} data={availableOptions} valueName="id" textName="sendToAddress" onChange={handleInvitationChange} size="medium" selectedIndex={selectedIndex} /> : null}
                        {type === "list" ? <DataBoundList data={availableOptions} valueName="id" textName="sendToAddress" onChange={handleInvitationChange} selectedIndex={selectedIndex} onBuildListItem={onBuildListItem} maxHeight={maxHeight} /> : null}
                    </>
                    : null}
                </>
            }</> : null}
    </>;
};

InvitationSelector.propTypes = {
    cardoom: PropTypes.object.isRequired,
    union: PropTypes.object.isRequired,
    club: PropTypes.object,
    readonly: PropTypes.bool,
    placeholder: PropTypes.string,
    emptyValue: PropTypes.object,
    onSelectionChanged: PropTypes.func,
    type: PropTypes.oneOf(["list", "dropdown"]),
    maxHeight: PropTypes.string
};

InvitationSelector.defaultProps = {
    readonly: false,
    placeholder: "please make a selection",
    emptyValue: { id: null, name: "None" },
    type: "dropdown",
    maxHeight: "200px"
};

export default InvitationSelector;